import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

import { getChannelsWithoutAddress } from '../../services/channel';

const ChannelsWithoutAddress = () => {
  const dispatch = useDispatch();
  const [issues, setChannels] = useState([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageTitle, setPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayChannelsWithoutAddress();
  }, []);

  const displayChannelsWithoutAddress = async (pages = 0) => {
    try {
      setIsLoading(true);
      const { data } = await getChannelsWithoutAddress(pages);
      setChannels(data.rows);
      setPageTitle('Channels without address');
      setTotalItems(data.count);
      setTotalPages(data.count/10);
      setPage(+data.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const handleChangePage = async page => {
    displayChannelsWithoutAddress(+page);
    setPage(+page);
  };

  const headers = ['uid', 'hasPaymentIntegration', 'addressId'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>
          {pageTitle} ({totalItems})
        </h1>
      </div>

      <DataTable
        useUid
        head={headers}
        body={issues}
        bodyColumn={headers}
        action={true}
        linkPath={'channels'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={handleChangePage}
        isNotOrdenable
      />
    </>
  );
};

export default ChannelsWithoutAddress;
